/* eslint-disable camelcase */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { selectUser } from './user'
import axios from 'axios'
import API from '../config'
import { get } from 'lodash-es'
import { getHeaders } from './api'

// ------------------------------------
// Constants
// ------------------------------------
const rootApi = `${API.apiPath}/${API.apiVersion}/`

const REQUEST_UPLOAD_IMAGE = 'REQUEST_UPLOAD_IMAGE'
const RECEIVE_IMAGE = 'RECEIVE_IMAGE'
const CLEAR_IMAGE = 'CLEAR_IMAGE'

// ------------------------------------
// Actions
// ------------------------------------
export const requestUploadImage = payload => ({ type: REQUEST_UPLOAD_IMAGE, payload })

const receiveImage = payload => ({ type: RECEIVE_IMAGE, payload })

export const clearImage = () => ({ type: CLEAR_IMAGE })

function* uploadImage(action) {
  const url = rootApi + 'deck/upload-temporary-image'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  try {
    const response = yield call(
      [axios, 'post'],
      url,
      {
        image_url: action.payload
      },
      {
        headers: getHeaders(token)
      }
    )
    if (get(response, 'status') === 200) {
      yield put(receiveImage(response.data.image_url))
    }
  } catch (e) {}
}

export function* uploadImageSaga() {
  yield takeLatest(REQUEST_UPLOAD_IMAGE, uploadImage)
}

const initialState = {
  image: null
}

export default function(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_IMAGE:
      return {
        image: action.payload
      }
    case CLEAR_IMAGE:
      return {
        image: null
      }
    default:
      return state
  }
}
